import { useEffect, useState } from "react";


import {
    Dialog,
    DialogContent,
    IconButton,
    CircularProgress,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import { searchPlugin } from "@react-pdf-viewer/search";
import axios from "axios";
//import { api_assinador_a1, path_anexos } from "../../../Utils/Urls";

import {
    IconButton as MIconButton,
    Tooltip,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";

import { LocalizationContext, SpecialZoomLevel } from '@react-pdf-viewer/core';

import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";


import { Button } from "@mui/material";





import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import "@react-pdf-viewer/search/lib/styles/index.css";

const ptBR = {
    search: {
        keyword: 'Buscar...',
        matchCase: 'Diferenciar maiúsculas/minúsculas',
        wholeWords: 'Palavras inteiras',
        previousMatch: 'Anterior',
        nextMatch: 'Próxima',
        numberOfMatches: '{{currentIndex}} de {{numberOfMatches}}',
        noMatch: 'Nenhum resultado encontrado',
        close: 'Fechar',
    },
};


interface Props {
    nomeArquivo: string[];
    modoImpressao?: boolean;
    open: boolean;
    onClose: () => void;
}

export const PdfView = ({
    nomeArquivo,
    modoImpressao = false,
    open,
    onClose,
}: Props) => {
    const [blobUrl, setBlobUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);



    const toolbarPluginInstance = toolbarPlugin();
    const { Toolbar } = toolbarPluginInstance;

    const searchPluginInstance = searchPlugin();
    const { ShowSearchPopoverButton } = searchPluginInstance;
    const { ShowSearchPopover } = searchPluginInstance;

    useEffect(() => {

        const fetchPdf = async () => {
            if (!open) return;
            setLoading(true);

            try {
                if (modoImpressao) {
                    //const pathOriginal = `${path_anexos}${nomeArquivo}`;
                    //console.log("nome arquivo em pdfview: ", nomeArquivo)
                    const response = await axios.post(
                        `https://sistema.sinsoft.com.br/ManipulacaoArquivosApi/Arquivo/merge`,
                        { paths:  nomeArquivo},
                        {
                            responseType: "blob",
                            headers: {
                                "Content-Type": "application/json",
                            },
                        }
                    );

                    if (response.status !== 200 || !response.data) {
                        throw new Error("Erro ao gerar versão impressa.");
                    }

                    const blob = new Blob([response.data], { type: "application/pdf" });
                    const url = URL.createObjectURL(blob);
                    setBlobUrl(url);
                }
            } catch (error) {
                console.error("Erro ao abrir o documento:", error);
                alert("Erro ao carregar o documento PDF.");
            } finally {
                setLoading(false);
            }
        };

        fetchPdf();
    }, [open, nomeArquivo, modoImpressao]);

    const buttonStyle: React.CSSProperties = {
        padding: "8px 16px",
        fontSize: "14px",
        border: "1px solid #ccc",
        background: "white",
        borderRadius: 6,
        cursor: "pointer",
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen
            PaperProps={{
                style: {
                    margin: 8,
                    borderRadius: 12,
                },
            }}
        >
            <DialogContent
                style={{
                    height: "calc(100vh - 16px)",
                    padding: 0,
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <IconButton
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        zIndex: 1000,
                        backgroundColor: "red",
                        color: "white",
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {loading ? (
                    <div
                        style={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <CircularProgress />
                    </div>
                ) : blobUrl ? (
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                            <div
                                style={{
                                    padding: "12px",
                                    borderBottom: "1px solid #ddd",
                                    background: "#f3f3f3",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    flexWrap: "wrap",
                                }}
                            >
                                <Toolbar>
    {(props) => {
        const {
            CurrentPageInput,
            GoToPreviousPage,
            GoToNextPage,
            NumberOfPages,
            Download,
            Print,
            ZoomIn,
            ZoomOut,
        } = props;

        return (
            <>
                <Tooltip title="Página anterior">
                    <GoToPreviousPage>
                        {(props) => (
                            <MIconButton {...props}>
                                <ArrowBackIcon />
                            </MIconButton>
                        )}
                    </GoToPreviousPage>
                </Tooltip>

                <Typography variant="body2">Página</Typography>
                <CurrentPageInput />
                <Typography variant="body2">de</Typography>
                <NumberOfPages />

                <Tooltip title="Próxima página">
                    <GoToNextPage>
                        {(props) => (
                            <MIconButton {...props}>
                                <ArrowForwardIcon />
                            </MIconButton>
                        )}
                    </GoToNextPage>
                </Tooltip>

                

                <Tooltip title="Imprimir">
                    <Print>
                        {(props) => (
                            <MIconButton {...props}>
                                <PrintIcon />
                            </MIconButton>
                        )}
                    </Print>
                </Tooltip>

                <Tooltip title="Baixar PDF">
                    <Download>
                        {(props) => (
                            <MIconButton {...props}>
                                <DownloadIcon />
                            </MIconButton>
                        )}
                    </Download>
                </Tooltip>

                <Tooltip title="Buscar no PDF">
                    <ShowSearchPopover>
                        {(props) => (
                            <MIconButton onClick={props.onClick}>
                                <SearchIcon />
                            </MIconButton>
                        )}
                    </ShowSearchPopover>
                </Tooltip>

                <Tooltip title="Reduzir Zoom">
                    <ZoomOut>
                        {(props) => (
                            <MIconButton {...props}>
                                <ZoomOutIcon />
                            </MIconButton>
                        )}
                    </ZoomOut>
                </Tooltip>

                <Tooltip title="Aumentar Zoom">
                    <ZoomIn>
                        {(props) => (
                            <MIconButton {...props}>
                                <ZoomInIcon />
                            </MIconButton>
                        )}
                    </ZoomIn>
                </Tooltip>
            </>
        );
    }}
</Toolbar>



                            </div>
                            <div style={{ flex: 1, overflow: "hidden" }}>
                                <LocalizationContext.Provider value={{ l10n: ptBR, setL10n: () => { } }}>


                                    <Viewer
                                        fileUrl={blobUrl}
                                        plugins={[toolbarPluginInstance, searchPluginInstance]}
                                        defaultScale={SpecialZoomLevel.PageFit}
                                    />
                                </LocalizationContext.Provider>
                            </div>
                        </div>
                    </Worker>
                ) : null}
            </DialogContent>
        </Dialog>
    );
};
